import { z } from 'zod';
import { emailRegex, nameRegex, phoneRegex } from '@/src/utils/regex';
import { UpsertAdministratorRequestBody } from '@/src/apis/rest/administrators.dtos';

export const DEFAULT_VALUES: UpsertAdministratorRequestBody = {
  aId: '',
  name: '',
  department: '',
  phone: '',
  isActivated: true,
  createdAt: '',
};

export const formSchema = () => {
  return z.object({
    aId: z
      .string()
      .min(1, '아이디를 입력해주세요.')
      .refine(
        value => emailRegex.test(value),
        '이메일 형식이 올바르지 않습니다.',
      ),
    name: z
      .string()
      .min(1, '이름을 입력해주세요.')
      .refine(value => nameRegex.test(value), '이름 형식이 올바르지 않습니다.'),
    department: z
      .string()
      .min(1, '소속을 입력해주세요.')
      .refine(
        value => /^[A-Za-z0-9가-힣ㄱ-ㅎ\-_~!?@#*()=\s]*$/.test(value),
        '소속 형식이 올바르지 않습니다.',
      ),
    phone: z
      .string()
      .min(1, '핸드폰 번호를 입력해주세요.')
      .refine(
        value => phoneRegex.test(value),
        '핸드폰 번호 형식이 올바르지 않습니다.',
      ),
    isActivated: z.boolean(),
  });
};

export const formFields = {
  aId: {
    name: 'aId',
    label: '아이디 (Email)',
    placeholder: '아이디 (Email)을 입력해주세요',
  },
  department: {
    name: 'department',
    label: '소속',
    placeholder: '소속을 입력해주세요',
  },
  name: {
    name: 'name',
    label: '이름',
    placeholder: '이름을 입력해주세요',
  },
  phone: {
    name: 'phone',
    label: '핸드폰 번호',
    placeholder: '핸드폰 번호를 입력해주세요',
  },
  isActivated: {
    name: 'isActivated',
    label: '사용 여부',
  },
  createdAt: {
    name: 'createdAt',
    label: '등록 일시',
  },
} as const;
